import { createContext, use } from "react";

interface IAssignmentReferenceBookingsModalContext {
	role: "host" | "partner";
	partnerOrgId: string;
	isApproved: boolean;
	/** Whether the record held bookings when the modal opened — the partner's, or the host's. */
	hasSavedBookings: boolean;
	/** The rows the host added in this session, the generated first row of an empty record included. */
	hostCreatedBookingIds: ReadonlySet<string>;
	/** Whether the host has answered the record — its first save marks it reviewed. */
	isReviewed: boolean;
	/**
	 * Whether the bookings carry the host's column at all. A partner filling an empty record has
	 * nothing answered and nothing to be answered yet, so there the column is left out and the
	 * partner's statement takes the width.
	 */
	hasHostColumn: boolean;
}

/** Context */
export const AssignmentReferenceBookingsModalContext =
	createContext<IAssignmentReferenceBookingsModalContext>(
		{} as IAssignmentReferenceBookingsModalContext,
	);

/** Hooks */
export function useAssignmentReferenceBookingsModalContext() {
	return use(AssignmentReferenceBookingsModalContext);
}
